module.exports = (__webpack_require__(0))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/rest.js from dll-reference girder_lib
// module id = 9
// module chunks = 0